import React, { Component } from 'react';
import FileUploader from './../../../commons/FileUploader.js';
import DownloadFile from './../../../commons/DownloadFile.js';

export default class MarkQCFail extends Component {
	render(){
		return(
			<div className="dump-ingestion-wrapper">
				<div className="white-box">
					<div className="page-header-title">
						Mark QC Fail
					</div>
					<div>
						<DownloadFile title="Download Mark QC Fail Template" url="ingest/inventory/transfer/item/template"/>
					</div>
					<div className="top-thirty">
						<FileUploader url="ingest/inventory/qc/fail"/>
					</div>
				</div>
			</div>);
	}
}


// WEBPACK FOOTER //
// ./src/screens/QC/Components/MarkQCFail.js